import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./css/index.css";
import useGetPost from "../../hooks/UseGetPost";
import PostListSection from "../../components/PostListSection/PostListSection";
import AddNavSection from "../../components/AddNavSection/AddNavSection";
import { AddState } from "../../interface/initialState";
import Emty from "../../components/Emty/Emty";

const bbs_id = 5;

function AddList() {
  const [data, PostRemove, PagingUpdate] = useGetPost({ bbs_id });
  const [type, setType] = useState<"normal" | "line">("normal");
  const [bannerData, setBannerData] = useState<any[]>([]);
  useEffect(() => {
    const filt = data.filter((item: typeof AddState) => {
      const { ctts_ctg_cd } = item;
      return ctts_ctg_cd === type;
    });
    setBannerData(filt);
    return () => {};
  }, [data, type]);

  return (
    <main className="addlist">
      <div className="wrapper">
        <AddNavSection type={type} setType={setType} />
        <div className="add-list-title-section">
          <div className="add-list-title">
            {type === "normal" ? "메인 배너" : "띠 배너"}
          </div>
          <Link
            to={type === "normal" ? "/add/new" : "/add/line/fix"}
            className="insert-new-add-btn"
          >
            <img src="/assets/common/cross.svg"></img>
            <div className="title">
              {type === "normal" ? "신규 메인 배너" : "신규 띠 배너"}
            </div>
          </Link>
        </div>
        {bannerData.length > 0 ? (
          <PostListSection
            tags={tagLayouts}
            type={type === "normal" ? "add" : "line"}
            data={bannerData}
            PostRemove={PostRemove}
            ProjectPause={undefined}
            category={undefined}
            ChangeProjectSts={undefined}
            __ChangeState={undefined}
            prjtData={undefined}
            PagingUpdate={PagingUpdate}
          />
        ) : (
          <Emty />
        )}
      </div>
    </main>
  );
}

export default AddList;

const tagLayouts = [
  {
    title: "이미지",
    type: "add-img",
  },
  {
    title: "타이틀",
    type: "add-title",
  },
  {
    title: "클릭횟수",
    type: "add-count",
  },
  {
    title: "노출여부",
    type: "add-show",
  },
  {
    title: "순서 조정",
    type: "add-index",
  },
];
